module.exports = __webpack_public_path__ + "h5/static/img/coinpor-logo.edf9d328.png";